module.exports = __webpack_public_path__ + "img/06.257c854a.png";